let nav = null;
let apikey = null;
let teacher = null;

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log("SW registered: ", registration);
      })
      .catch((registrationError) => {
        console.log("SW registration failed: ", registrationError);
      });
  });
}

window.login = () => {
  if (!required()) {
    return false;
  }
  $("ons-progress-bar").show();
  $.ajax({
    type: "POST",
    dataType: "json",
    url: apiurl + "login",
    data: JSON.stringify({
      email: $("#email").val(),
      pass: $("#pass").val(),
    }),
    success: function (response) {
      $("ons-progress-bar").hide();
      if (response.apikey) {
        localStorage.setItem("apikey", response.apikey);
        parse(response);
      } else {
        ons.notification.toast("Κατι πήγε λάθος! Δοκιμάστε ξανά.", {
          timeout: 2000,
        });
        setTimeout(function () {
          $("ons-button.forget_pass").fadeIn();
        }, 3000);
      }
    },
  });
};

window.forget_pass = () => {
  if (!required()) {
    return false;
  }
  $("ons-progress-bar").show();
  $.ajax({
    type: "POST",
    dataType: "json",
    url: apiurl + "forget_pass",
    data: JSON.stringify({
      email: $("#email_forget").val(),
      url: location.href,
    }),
    success: function (response) {
      $("ons-progress-bar").hide();
      if (response.success) {
        window.show_login();
      } else {
        ons.notification.toast("Δεν υπάρχει χρήστης με αυτό το email.", {
          timeout: 2000,
        });
        $("#email_forget").val("");
      }
    },
  });
};

window.change_pass = () => {
  if (!required()) {
    return false;
  }
  $("ons-progress-bar").show();
  $.ajax({
    type: "POST",
    dataType: "json",
    url: apiurl + "change_pass",
    data: JSON.stringify({
      apikey: localStorage.getItem("apikey"),
      pass: $("#pass").val(),
      reset: $("#reset").val(),
      new_pass: $("#new_pass").val(),
      repeat_pass: $("#repeat_pass").val(),
    }),
    success: function (response) {
      $("ons-progress-bar").hide();
      if (response.success) {
        window.logout();
      } else {
        ons.notification.toast("Κατι πήγε λάθος! Δοκιμάστε ξανά.", {
          timeout: 2000,
        });
        $("#pass,#new_pass,#repeat_pass").val("");
      }
    },
  });
};

window.logout = () => {
  if (teacher != null) {
    teacher = null;
    localStorage.removeItem("apikey");
    nav.resetToPage("views/login.html?" + hash);
  } else {
    location.href = "/";
  }
};

window.parse = (response) => {
  if (!response.success) {
    logout();
    return;
  }
  teacher = response;

  nav.resetToPage("views/home.html?" + hash);
};

window.required = () => {
  let ok = true;
  $("input[required],select[required]").each(function () {
    if ($(this).attr("type") != "hidden" && $(this).is(":hidden")) {
      return true;
    }
    if ($(this).attr("type") == "checkbox" && !this.checked) {
      ok = false;
      return false;
    }
    if ($(this).parent().hasClass("error")) {
      ok = false;
      return false;
    }
    if (!$(this).val() || $(this).val() == "0") {
      ok = false;
      return false;
    }
  });
  return ok;
};

window.upload = (inp, fld) => {
  const output = inp.files[0];
  const formData = new FormData();
  formData.append("apikey", localStorage.getItem("apikey"));
  formData.append("photo", fld);
  formData.append("file", output, output.name);

  $("#loader_" + fld).show();
  $("#camera_" + fld).hide();
  $.ajax({
    type: "POST",
    dataType: "json",
    url: apiurl + "upload_photo",
    data: formData,
    processData: false,
    contentType: false,
    timeout: 300000,
    success: function (response) {
      $("#loader_" + fld).fadeOut();
      if (response.success) {
        $("ons-card.student").append(
          '<img style="width:100%" src="' + response.photo + '"/>'
        );
      }
    },
    error: function () {
      $("#loader_" + fld).fadeOut();
      $("#camera_" + fld).show();
    },
  });
};

function setEndOfContenteditable(contentEditableElement) {
  var range, selection;
  if (document.createRange) {
    //Firefox, Chrome, Opera, Safari, IE 9+
    range = document.createRange(); //Create a range (a range is a like the selection but invisible)
    range.selectNodeContents(contentEditableElement); //Select the entire contents of the element with the range
    range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
    selection = window.getSelection(); //get the selection object (allows you to change selection)
    selection.removeAllRanges(); //remove any selections already made
    selection.addRange(range); //make the range you have just created the visible selection
  } else if (document.selection) {
    //IE 8 and lower
    range = document.body.createTextRange(); //Create a range (a range is a like the selection but invisible)
    range.moveToElementText(contentEditableElement); //Select the entire contents of the element with the range
    range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
    range.select(); //Select the range (make it the visible selection
  }
}

window.open_notes = () => {
  if (!$("#notes").attr("contenteditable")) {
    $("#notes").attr("contenteditable", true).focus();
    setEndOfContenteditable($("#notes")[0]);
  }
};

window.save_notes = (student_id) => {
  $("#notes").attr("contenteditable", "");
  $.ajax({
    type: "POST",
    dataType: "json",
    url: apiurl + "save_notes",
    data: JSON.stringify({
      apikey: localStorage.getItem("apikey"),
      student_id: student_id,
      notes: $("#notes").html(),
    }),
  });
};

window.home = () => {
  nav.resetToPage("views/home.html?" + hash);
};

window.show_login = () => {
  nav.resetToPage("views/login.html?" + hash);
};

window.show_forget_pass = () => {
  nav.pushPage("views/forget_pass.html?" + hash);
};

window.show_change_pass = () => {
  nav.pushPage("views/change_pass.html?" + hash);
};

window.show_class = (c) => {
  nav.pushPage("views/class.html?" + hash, {
    data: {
      class: c,
    },
  });
};

window.show_student = (c, id) => {
  nav.pushPage("views/student.html?" + hash, {
    data: {
      class: c,
      student_id: id,
    },
  });
};

window.help = (section) => {
  nav.pushPage("views/help_" + section + ".html?" + hash);
};

ons.ready(function () {
  nav = $("#navigator")[0];

  if (document.location.search.indexOf("reset=") > -1) {
    localStorage.removeItem("apikey");
    nav.resetToPage("views/change_pass.html?" + hash, {
      data: {
        reset: document.location.search.split("reset=")[1],
      },
    });
    return;
  }

  apikey = localStorage.getItem("apikey");
  if (!apikey) {
    nav.resetToPage(
      apikey ? "views/home.html?" + hash : "views/login.html?" + hash
    );
    return;
  }

  $.ajax({
    type: "POST",
    dataType: "json",
    url: apiurl + "get_teacher",
    data: JSON.stringify({
      apikey: localStorage.getItem("apikey"),
    }),
    success: function (response) {
      parse(response);
    },
  });
});

showPhoto = (fld, photo) => {
  if (photo) {
    return '<img class="photo" src="' + photo + '"/>';
  }
  return (
    '<div style="margin-top:10px;" id="photo_' +
    fld +
    '" class="photo"></div>\
              <input type="hidden" name="' +
    fld +
    '" id="fld_' +
    fld +
    '" value=""></input>\
              <input name="file" type="file" accept="image/jpeg" style="display:none" id="upload_' +
    fld +
    '" onchange="window.upload(this,\'' +
    fld +
    '\')"></input>\
              <label style="width:100%" for="upload_' +
    fld +
    '"><ons-icon id="camera_' +
    fld +
    '" icon="fa-camera"></ons-icon>\
              <ons-progress-circular id="loader_' +
    fld +
    '" style="width:18px;height:14px;margin-left:4px;display:none" indeterminate></ons-progress-circular></label>'
  );
};

document.addEventListener("postpush", function (event) {
  let html = "";
  const page = event.enterPage;

  if (page.id === "home") {
    html = "<h1>" + teacher.name + "</h1>";
    if (teacher.title) {
      html += '<div class="title">' + teacher.title + "</div>";
    }
    $("#home ons-card").append(html);
    $.each(teacher.classes, function (_, c) {
      $("ons-row").append(
        '<ons-col width="27%" style="margin:10px;text-align:center">' +
          '<ons-button style="font-size:20px;padding:20px 0px;" modifier="large" onclick="window.show_class(\'' +
          c +
          "')\">" +
          c +
          "</ons-button></ons-col>"
      );
    });
  } // home

  if (page.id === "class") {
    $("ons-progress-bar").show();

    const c = page.data.class;
    $("#class ons-card").append("<h1>" + c + "</h1>");

    $.ajax({
      type: "POST",
      dataType: "json",
      url: apiurl + "get_class",
      data: JSON.stringify({
        apikey: localStorage.getItem("apikey"),
        class: c,
      }),
      success: function (response) {
        $("ons-progress-bar").hide();
        if (response.success) {
          $.each(response.students, function (_, student) {
            html +=
              "<ons-list-item tappable><div onclick=\"window.show_student('" +
              c +
              "','" +
              student.id +
              '\')" class="center">' +
              student.name +
              "</div></ons-list-item>";
          });

          $("ons-list").append(html);
        }
      },
    });
  }

  if (page.id === "student") {
    $("ons-progress-bar").show();

    $.ajax({
      type: "POST",
      dataType: "json",
      url: apiurl + "get_student",
      data: JSON.stringify({
        apikey: localStorage.getItem("apikey"),
        student_id: page.data.student_id,
      }),
      success: function (response) {
        $("ons-progress-bar").hide();
        if (response.success) {
          const student = response.student;
          $("ons-card.student").append(
            "<h1>" +
              student.name +
              "</h1>" +
              '<div class="title">' +
              student.class +
              "</div>" +
              showPhoto("students_" + student.id + "_photo", student.photo)
          );
          if (student.notes) {
            $("#notes").html(student.notes);
          }
          $("#notes").on("blur", function () {
            window.save_notes(student.id);
          });
        }
      },
    });
  }

  if (page.id == "change_pass") {
    if (page.data.reset) {
      $("input#reset").val(page.data.reset);
      $("#pass").parent().hide();
    }
  } // change_pass
});

document.addEventListener("postpop", function (event) {});
